import { PencilBaseIcon } from '@tableau/icons/PencilBaseIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

export type EditDomainButtonProps = Readonly<{
    onClick: () => void;
}>;

export function EditDomainButton(props: EditDomainButtonProps) {
    return (
        <ButtonWidget
            testId="edit-domain-button"
            buttonType={ButtonType.Icon}
            onClick={props.onClick}
            title={Messages.bridgeSiteSettingsEditDomain()}
            aria-label={Messages.bridgeSiteSettingsEditDomain()}
        >
            <PencilBaseIcon size={14} aria-hidden={true} />
        </ButtonWidget>
    );
}
